import React, { useState } from 'react';
import { Button, Card, Input, Tag, Typography } from 'antd';

const { Text } = Typography;
const { TextArea } = Input;

const STATUS_OPCOES = [
  { value: 'PRESENTE', label: 'Presente' },
  { value: 'AUSENTE', label: 'Ausente' },
  { value: 'JUSTIFICADA', label: 'Justificada' },
];

const STATUS_TAG_COLOR = {
  PRESENTE: 'green',
  AUSENTE: 'red',
  JUSTIFICADA: 'orange',
};

const labelDoStatus = (status) => STATUS_OPCOES.find((opcao) => opcao.value === status)?.label || status;

const ProfessorAlunoFrequenciaCard = ({
  nomeCompleto,
  status,
  observacao,
  somenteLeitura = false,
  onChangeStatus,
  onChangeObservacao,
}) => {
  const [observacaoAberta, setObservacaoAberta] = useState(Boolean(observacao));

  return (
    <Card className="professor-aluno-card" size="small">
      <Text strong className="professor-aluno-nome">
        {nomeCompleto}
      </Text>

      {somenteLeitura ? (
        <>
          <div className="professor-aluno-status-leitura">
            {status ? (
              <Tag color={STATUS_TAG_COLOR[status] || 'default'}>{labelDoStatus(status)}</Tag>
            ) : (
              <Tag>Não informado</Tag>
            )}
          </div>
          {observacao && (
            <Text type="secondary" className="professor-aluno-observacao-texto">
              {observacao}
            </Text>
          )}
        </>
      ) : (
        <>
          <div
            role="group"
            aria-label={`Frequência de ${nomeCompleto}`}
            className="professor-aluno-status-grupo"
          >
            {STATUS_OPCOES.map((opcao) => (
              <Button
                key={opcao.value}
                type={status === opcao.value ? 'primary' : 'default'}
                aria-pressed={status === opcao.value}
                onClick={() => onChangeStatus(opcao.value)}
                className="professor-aluno-status-btn"
              >
                {opcao.label}
              </Button>
            ))}
          </div>

          {observacaoAberta ? (
            <TextArea
              className="professor-aluno-observacao-input"
              placeholder="Observação (opcional)"
              autoSize={{ minRows: 1, maxRows: 3 }}
              value={observacao}
              onChange={(e) => onChangeObservacao(e.target.value)}
              aria-label={`Observação de ${nomeCompleto}`}
            />
          ) : (
            <Button
              type="link"
              className="professor-aluno-observacao-toggle"
              onClick={() => setObservacaoAberta(true)}
            >
              Adicionar observação
            </Button>
          )}
        </>
      )}
    </Card>
  );
};

export default ProfessorAlunoFrequenciaCard;
